import httpClient from "../Core/http";

class Api {
  getJiraIssues(): Promise<any> {
    let url = "jira";
    return httpClient
      .get<any[]>(url)
      .then((response: any) => {
        return response.data;
      })
      .catch((error) => console.log(error.message));
  }
}

export const JiraApi = new Api();
